import { render } from "./ModalCreateUser.vue?vue&type=template&id=76afd61b"
import script from "./ModalCreateUser.vue?vue&type=script&lang=js"
export * from "./ModalCreateUser.vue?vue&type=script&lang=js"

import "./ModalCreateUser.vue?vue&type=style&index=0&id=76afd61b&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__